import React from "react";
import Home from "../components/Home";

const LandingPage = () => {
  return (
    <div>
      <Home />
    </div>
  );
};

export default LandingPage;
